import React from 'react';

export const WhiteMailIcon = ({ size }: { size?: string }) => (
  <svg
    width={size || "24"}
    height={size || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <rect y="2.37231" width="24" height="19.2554" fill="url(#pattern1)"/>
    <defs>
      <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlinkHref="#image0_1026_1295" transform="matrix(0.0124175 0 0 0.0154773 -0.0960419 -0.242908)"/>
      </pattern>
      <image id="image0_1026_1295" width="96" height="96" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAC10lEQVR4nO3cv2oUURTH8YuRCELSK0QfIBGt9CUMNtpa+gq+go1BQ1RsLbURbNVaKwW1VyH2+WNl5CujsxgWsjP33nPnzO79fSCQInBuzi+Z306yTAgiIiIiIiIiIiIiIiJTgEvAQ+AzcIgctrt4AGwU+4EBzgCPgd/a+Yma3TwClkss/+3Jc2XKG9MQgCfTE6TTjuU1X5edeEfAukUATeFKmi2LAL4kDhf4ZBHAgTaZbN8igJlC5Si9HwUwmwJwpgBqDwB4BVwIlQHOAc/GEEDjJ3AXWAoLDjgF3AH2+izGYmCMD8DVsKCAy8C7mIVYDI3V/NniKbASFgRwFrgH/IpdhsXwVLvAzTDngOvA19QlWBwg11yWND1Ldh4CmKuSJrJku1gcyNKoS5qEku1icagum8C3eS5p/pds8zf8vn4At7u+yOJwnQMSv4HdMZR0QslOfoBW++4n94C9BwBXgPfMQUmTVrIfgWup+0k9aNSAYyW2P8aSJq1kJ+c7nbuflAMnDQDOAy8YUUmT/ht60Xo/MYfOGjCGkiajZEvvJwwxIKOkbxmcfzOnZIfYz2ADhixp/l0Cs0t2yP0MMqB0SZNXskve+xlsQImSpkDJeu1nsAGkl/TqECVbxbsigJX27d0xC/wO3Gg/ms/7OmpnmbzKKr6f4gPyLyGu9xnF91N8gE1Ju91pF99P8QGzS/q5wfKzSrbaADJK+viNXHbJhtoDSHiVE3Unm6uKACJKevD/uFUVwIw7Xbf/OVcXwASwBrxsP9aCk2oDGAsF4EwBOFMAzhSAMwXgTAE4UwDOFIAzBeBMAThTAM4UgDMF4EwBOFMAFQSgBzal27MIQI8sc35kWfM2Pklz3yKAjcj3bIrlYyvbEJrH8UqcbZPltwEst4/jlX5el3h+dBPCji5HnZedbfPlTwWx3jwRtml4vUT966DdxZbZNV9ERERERERERERERMIi+QPE8WG2LAetLAAAAABJRU5ErkJggg=="/>
    </defs>
  </svg>

)
